import { Evento } from "./types";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchEvento(lang: Locale): Promise<Evento[]> {
  const res = await fetchWithRetry<{ data: Evento[] }>(
    `/mkeventos?lang=${cmsLang(lang)}`,
    {},
    3,
  );
  return res.data;
}
